import React, {
	useCallback,
	useContext,
	useEffect,
	useState,
	useRef,
} from 'react';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import { devis, no_waiting_element } from '../../../utils/images';
import { ExpertContext } from '../../Contexts/contexts';
import QuoteElementExpert from '../QuoteElementExpert/QuoteElementExpert';
import HeaderMinimal from '../../Shared/Headers/HeaderMinimal';
import { shouldFetchData, status } from '../../../data/fetchStatus';
import useToast from '../../Toasts/useToast';
import {
	ToastHeaders,
	ToastThemes,
	ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import Services from '../../Services/services';
import useAuth from '../../Contexts/useAuth';
import useCheckout from '../../Contexts/useCheckout';
import usePaymentPeriod from '../../Contexts/usePaymentPeriod';

function WaitingAcceptationExpert() {
	const expertContext = useContext(ExpertContext);

	const [clients, setClients] = useState([]);
	const [clientsFetched, setClientsFetched] = useState(status.DEFAULT);

	const enqueueToast = useToast();
	const { checkAuth, validateRoleRoute } = useAuth();
	const checkout = useCheckout();
	const checkPaymentPeriod = usePaymentPeriod();
	const ref = useRef(true);

	const fetchClients = useCallback(async () => {
		if (
			expertContext?.clientExpertRelations?.length === 0 ||
			clientsFetched === status.FETCHED
		)
			return;

		setClientsFetched(status.FETCHED);

		try {
			let clientsIds = [];

			expertContext
				?.getClientExpertRelationsByStatus([0, 1])
				.forEach((clientExpertRelation) => {
					clientsIds.push(clientExpertRelation.clientId);
				});

			const data = await Services.profileService.clientsByIDs(clientsIds, true);

			if (data.length === 0) return;

			setClients(data);
		} catch (error) {
			enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
				duration: 3000,
			});
		}
	}, [expertContext, clientsFetched, enqueueToast]);

	useEffect(() => {
		if (checkAuth()) {
			if (validateRoleRoute('expert')) {
				if (checkout('/waiting-acceptation')) {
					if (checkPaymentPeriod('/waiting-acceptation')) {
						const firstRendering = ref.current;

						if (firstRendering) {
							ref.current = false;
							expertContext?.refreshClientExpertRelations();
							expertContext?.refreshAppointments();
						} else {
							if (shouldFetchData(clientsFetched)) fetchClients();
						}
					}
				}
			}
		}
	}, [
		clientsFetched,
		fetchClients,
		checkAuth,
		validateRoleRoute,
		checkout,
		checkPaymentPeriod,
		expertContext,
	]);

	// Fonction qui permet d'afficher les noms des ficihiers dropped
	function getAllWaitingElements() {
		const waitingElementsItems = [];

		expertContext
			?.getClientExpertRelationsByStatus([0, 1])
			.forEach((clientExpertRelation) => {
				waitingElementsItems.push(
					<QuoteElementExpert
						clientExpertRelation={clientExpertRelation}
						client={clients?.find(
							(client) =>
								client?.userId === clientExpertRelation?.client?.userId
						)}
						key={clientExpertRelation.id}
					/>
				);
			});

		return waitingElementsItems;
	}

	return (
		<>
			<HeaderMinimal />
			<div className="ts-container waiting-acceptation-expert">
				<SideMenu />
				<div className="ts-container-column">
					<div className="ts-details-container">
						<div className="ts-details">
							<div className="ts-title">Client en attente d’acceptation</div>
							<div className="ts-resume">
								Vous avez des demandes de rendez-vous en attente. Consultez-les
								en cliquant sur l'icône en forme d'œil à droite de chaque
								demande. Chaque demande inclut le montant estimé du devis et les
								infos du client. Une fois acceptée ou refusée, proposez 5
								rendez-vous. Attendez l'acceptation du client, puis confirmez la
								signature après l'acceptation du rendez-vous.
							</div>
						</div>
						<div className="ts-number">
							<div className="ts-number-container">
								<div className="ts-number-title">En attente d’acceptation</div>
								<div className="ts-number-current">
									{
										expertContext?.getClientExpertRelationsByStatus([0, 1])
											.length
									}
								</div>
							</div>
							<img className="ts-icon" src={devis} alt="devis icone"></img>
							<div className="yellow-rod"></div>
						</div>
					</div>

					{expertContext?.getClientExpertRelationsByStatus([0, 1]).length >
					0 ? (
						<div className="waiting-container">
							<div className="waiting-nomenclature">
								<span className="waiting-nomenclature-demand">Demande</span>
								<span className="waiting-nomenclature-amount">
									Montant estimé
								</span>
							</div>
							<div className="waiting-elements-container">
								{getAllWaitingElements()}
							</div>
						</div>
					) : (
						<div className="no-element-container">
							<img
								className="no-element-img"
								src={no_waiting_element}
								alt="no element"
							/>
							<div className="no-element-details">
								<div className="no-element-upper">
									<div className="no-element-title">
										Veuillez attendre que des clients sélectionne un devis dont
										vous serez l'expert pour être mis en relation
									</div>
									<div className="no-element-text">
										Une fois un devis sélectionné, vous serez notifié par mail
										qu'une demande est en attente.
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
}

export default WaitingAcceptationExpert;
